import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { CheckboxControlValueAccessorDirective } from './checkbox-control-value-accessor.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ControlHintComponent, InheritedControlValueAccessorComponent } from '@knorr-bremse-portals/ngx-components/internal/controls';

@Component({
  selector: 'kb-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, ControlHintComponent, FormsModule, CheckboxControlValueAccessorDirective ],
})
export class CheckboxComponent extends InheritedControlValueAccessorComponent<boolean> {

  protected controlId = `kb-checkbox-${this.uniqueId}`;

  @Input() public on?: 'background';

  @Input() public standalone = false;

  @Input() public showRequired = true;

  @ViewChild(CheckboxControlValueAccessorDirective) protected valueAccessor!: CheckboxControlValueAccessorDirective;

}
